<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <vehicle-type-control></vehicle-type-control>
      <vehicle-type-view></vehicle-type-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleTypeControl from "@/components/vehicleTypes/vehicleTypeControl";
import VehicleTypeView from "@/components/vehicleTypes/vehicleTypeView";

export default {
  components: {
    VehicleTypeControl,
    VehicleTypeView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
